<app-dialog [config]="createModifyDialogConfig" (onApply)="onApplyE.emit($event)"></app-dialog>
